module.exports = __webpack_public_path__ + "img/about-bkg-3.png";